// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSignatureRequestToJson, getSignatureResponseFromJson, sendEmailUsingEmailBuilderRequestToJson, sendEmailUsingEmailBuilderResponseFromJson, sendFromAuthorizedDomainRequestToJson, sendFromAuthorizedDomainResponseFromJson, sendFromProviderRequestToJson, sendFromProviderResponseFromJson, sendPreviewEmailUsingEmailBuilderRequestToJson, sendPreviewEmailUsingEmailBuilderResponseFromJson, sendWhitelabelEmailToUserRequestToJson, sendWhitelabelEmailToUserResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function sendWhitelabelEmailToUser(request) {
    const raw = await fetchRpc('email.v1.Send/SendWhitelabelEmailToUser', sendWhitelabelEmailToUserRequestToJson(request));
    return sendWhitelabelEmailToUserResponseFromJson(raw);
}
export function sendWhitelabelEmailToUser$(request, options) {
    return defer(() => sendWhitelabelEmailToUserWithTransport$(getGlobalTransport(), request, options));
}
export function sendWhitelabelEmailToUserWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/SendWhitelabelEmailToUser', sendWhitelabelEmailToUserRequestToJson(request), options)
        .pipe(map(resp => sendWhitelabelEmailToUserResponseFromJson(resp)));
}
export async function sendFromAuthorizedDomain(request) {
    const raw = await fetchRpc('email.v1.Send/SendFromAuthorizedDomain', sendFromAuthorizedDomainRequestToJson(request));
    return sendFromAuthorizedDomainResponseFromJson(raw);
}
export function sendFromAuthorizedDomain$(request, options) {
    return defer(() => sendFromAuthorizedDomainWithTransport$(getGlobalTransport(), request, options));
}
export function sendFromAuthorizedDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/SendFromAuthorizedDomain', sendFromAuthorizedDomainRequestToJson(request), options)
        .pipe(map(resp => sendFromAuthorizedDomainResponseFromJson(resp)));
}
export async function sendFromProvider(request) {
    const raw = await fetchRpc('email.v1.Send/SendFromProvider', sendFromProviderRequestToJson(request));
    return sendFromProviderResponseFromJson(raw);
}
export function sendFromProvider$(request, options) {
    return defer(() => sendFromProviderWithTransport$(getGlobalTransport(), request, options));
}
export function sendFromProviderWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/SendFromProvider', sendFromProviderRequestToJson(request), options)
        .pipe(map(resp => sendFromProviderResponseFromJson(resp)));
}
export async function sendPreviewEmailUsingEmailBuilder(request) {
    const raw = await fetchRpc('email.v1.Send/SendPreviewEmailUsingEmailBuilder', sendPreviewEmailUsingEmailBuilderRequestToJson(request));
    return sendPreviewEmailUsingEmailBuilderResponseFromJson(raw);
}
export function sendPreviewEmailUsingEmailBuilder$(request, options) {
    return defer(() => sendPreviewEmailUsingEmailBuilderWithTransport$(getGlobalTransport(), request, options));
}
export function sendPreviewEmailUsingEmailBuilderWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/SendPreviewEmailUsingEmailBuilder', sendPreviewEmailUsingEmailBuilderRequestToJson(request), options)
        .pipe(map(resp => sendPreviewEmailUsingEmailBuilderResponseFromJson(resp)));
}
export async function sendEmailUsingEmailBuilder(request) {
    const raw = await fetchRpc('email.v1.Send/SendEmailUsingEmailBuilder', sendEmailUsingEmailBuilderRequestToJson(request));
    return sendEmailUsingEmailBuilderResponseFromJson(raw);
}
export function sendEmailUsingEmailBuilder$(request, options) {
    return defer(() => sendEmailUsingEmailBuilderWithTransport$(getGlobalTransport(), request, options));
}
export function sendEmailUsingEmailBuilderWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/SendEmailUsingEmailBuilder', sendEmailUsingEmailBuilderRequestToJson(request), options)
        .pipe(map(resp => sendEmailUsingEmailBuilderResponseFromJson(resp)));
}
export async function getSignature(request) {
    const raw = await fetchRpc('email.v1.Send/GetSignature', getSignatureRequestToJson(request));
    return getSignatureResponseFromJson(raw);
}
export function getSignature$(request, options) {
    return defer(() => getSignatureWithTransport$(getGlobalTransport(), request, options));
}
export function getSignatureWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Send/GetSignature', getSignatureRequestToJson(request), options)
        .pipe(map(resp => getSignatureResponseFromJson(resp)));
}
